module.exports = __webpack_public_path__ + "static/taro-and-hanako-0fa8cfaace47a11814e997c98a23e03e.png";